<template>
    <div>
        <h1>{{ $t('opsummering')}}</h1>

        <!-- Vis 'loading' ikon mens API data loader... -->
        <img v-if="this.$store.getters.loading === true" src="@/assets/loading.svg" alt="">


        <div>
            <!-- <p>Rooms {{ this.rooms }}</p> -->
            <!-- {{this.$store.getters.bookingInProgress}}<br /> -->
            <!-- {{this.$store.getters.summaryData}} <br /> -->
            <!-- <p>Loading: {{this.$store.getters.loading}}</p> -->
            <!-- <p>DetailedEkstras summaryData: {{this.$store.getters.summaryData.detailedExtras}}</p> <br /> -->
            <!-- <p>DetailedEkstras: {{ this.$store.getters.bookingInProgress.detailedEkstras }}</p> -->
        </div>

        <div class="tabel">
             <table class="opsummeringIndhold">
                 <thead v-if="this.$store.getters.summaryData.rooms">
                     <tr>
                        <th scope="col" width="22%">{{ $t('type') }}</th>
                        <th scope="col" width="12%">{{ $t('vaerelse') }}</th>
                        <th scope="col" width="18%">{{ $t('ankomst') }}</th>
                        <th scope="col" width="15%">{{ $t('afrejse') }}</th>
                        <th scope="col" width="15%">{{ $t('naetter') }}</th>
                        <!-- <th scope="col" width="11%">Valuta</th> -->
                        <th scope="col" width="18%">{{ $t('pris') }}</th>
                     </tr>
                 </thead>
                 <tbody v-if="this.$store.getters.summaryData.rooms">
                     <tr v-for="rooms in this.$store.getters.summaryData.rooms" v-bind:key="rooms.roomnr">
                         <!-- <td v-bind:data-label="$t('type')">{{ $t('vaerelse') }}</td> -->
                         <td v-html="rooms.roomtype" v-bind:data-label="$t('type')">{{ rooms.roomtype }}</td>

                         <td v-if="$store.getters.summaryData.postnr == 2771" v-bind:data-label="$t('vaerelse')">-</td> <!-- Hvis postnr 2771 så fjern værelsesnummer -->
                         <td v-else v-bind:data-label="$t('vaerelse')">{{rooms.roomnr}}</td>

                         <td v-bind:data-label="$t('ankomst')">{{rooms.arrival}}</td>
                         <td v-bind:data-label="$t('afrejse')">{{rooms.departure}}</td>
                         <td v-bind:data-label="$t('naetter')">{{rooms.days}}</td>
                         <!-- <td data-label="valuta">DKK</td> -->
                         <td v-bind:data-label="$t('pris')">{{rooms.totalPrice.toLocaleString('da-DK', {style: 'currency', currency: 'DKK'})}}</td>
                     </tr>
                    <tr>
                         <td colspan='7'>&nbsp;</td>
                     </tr>
                 </tbody>




                 <thead v-if="this.$store.getters.summaryData.conference">
                     <tr>
                        <th scope="col" width="15%">{{ $t('type') }}</th>
                        <th scope="col" width="15%">{{ $t('lokale') }}</th>
                        <th scope="col" width="18%">{{ $t('ankomst') }}</th>
                        <th scope="col" width="18%">{{ $t('afrejse') }}</th>
                        <th scope="col" width="14%">{{ $t('naetter') }}</th>
                        <!-- <th scope="col" width="11%">Valuta</th> -->
                        <th scope="col" width="21%">{{ $t('pris') }}</th>
                     </tr>
                 </thead>
                 <tbody v-if="this.$store.getters.summaryData.conference">
                     <tr v-for="rooms in this.$store.getters.summaryData.conference" v-bind:key="rooms.roomnr">
                         <td v-bind:data-label="$t('type')">{{ $t('C') }}</td>
                         <td v-bind:data-label="$t('lokale')">{{rooms.roomnr}}</td>
                         <td v-bind:data-label="$t('ankomst')">{{rooms.arrival}}</td>
                         <td v-bind:data-label="$t('afrejse')">{{rooms.departure}}</td>
                         <td v-bind:data-label="$t('naetter')">{{rooms.days}}</td>
                         <!-- <td data-label="valuta">DKK</td> -->
                         <td v-bind:data-label="$t('pris')">{{rooms.totalPrice.toLocaleString('da-DK', {style: 'currency', currency: 'DKK'})}}</td>
                     </tr>
                    <tr>
                         <td colspan='7'>&nbsp;</td>
                     </tr>

                 </tbody>





                 <thead v-if="this.$store.getters.summaryData.parkings">
                     <tr>
                        <th scope="col" width="15%">{{ $t('type') }}</th>
                        <th scope="col" width="15%">{{ $t('pplads') }}</th>
                        <th scope="col" width="18%">{{ $t('ankomst') }}</th>
                        <th scope="col" width="18%">{{ $t('afrejse') }}</th>
                        <th scope="col" width="14%">{{ $t('naetter') }}</th>
                        <!-- <th scope="col" width="11%">Valuta</th> -->
                        <th scope="col" width="21%">{{ $t('pris') }}</th>
                     </tr>
                 </thead>
                 <tbody v-if="this.$store.getters.summaryData.parkings">
                     <tr v-for="parkings in this.$store.getters.summaryData.parkings" v-bind:key="parkings.space_no">
                         <td :data-label="$t('type')" >{{ $t('parkering') }}</td>
                         <td :data-label="$t('pplads')">{{parkings.space_no}}</td>
                         <td :data-label="$t('ankomst')">{{parkings.arrival}}</td>
                         <td :data-label="$t('afrejse')">{{parkings.departure}}</td>
                         <td :data-label="$t('naetter')">{{parkings.days}}</td>
                         <!-- <td data-label="valuta">DKK</td> -->
                         <td :data-label="$t('pris')">{{parkings.totalPrice.toLocaleString('da-DK', {style: 'currency', currency: 'DKK'})}}</td>
                     </tr>
                    <tr>
                         <td colspan='7'>&nbsp;</td>
                     </tr>

                 </tbody>





                <!-- Ekstra tilkøb Header -->
                <thead v-if="this.$store.getters.summaryData.extras || this.$store.getters.summaryData.detailedExtras">
                     <tr>
                        <!-- <th scope="col" colspan="4">{{ $t('ekstra') }}</th> -->
                        <!-- <th scope="col">{{ $t('antal') }}</th> -->
                        <!-- <th scope="col">Valuta</th> -->
                        <!-- <th scope="col">{{ $t('pris') }}</th> -->

                        <th scope="col" colspan="1">{{ $t('ekstra') }}</th>
                        <th scope="col">{{ $t('vaerelse') }}</th>
                        <th scope="col">{{ $t('antal') }}</th>
                        <th scope="col">{{ $t('dato') }}</th>
                        <th scope="col">{{ $t('prisstk') }}</th>
                        <th scope="col">{{ $t('pris') }}</th>

                     </tr>
                 </thead>


                <!-- Standard extra tilkøb -->
                 <tbody v-if="this.$store.getters.summaryData.extras">
                     <tr v-for="extras in this.$store.getters.summaryData.extras" v-bind:key="extras.id">
                         <td v-bind:data-label="$t('ekstra')" colspan="1">{{extras.headline}}</td>
                         <td v-bind:data-label="$t('vaerelse')">-</td>
                         <td v-bind:data-label="$t('antal')">{{extras.qty}}</td>
                         <td data-label="dato">-</td>
                         <td v-bind:data-label="$t('pris')">{{(extras.totalPrice/extras.qty).toLocaleString('da-DK', {style: 'currency', currency: 'DKK'})}}</td>
                         <td v-bind:data-label="$t('pris')">{{extras.totalPrice.toLocaleString('da-DK', {style: 'currency', currency: 'DKK'})}}</td>
                     </tr>
                 </tbody>



                <!-- Detaljeret Ekstra tilkøb -->
                 <tbody v-if="this.$store.getters.summaryData.detailedExtras">
                     <template v-for="(extraId, keyExtraId, indexExtraId) in this.$store.getters.summaryData.detailedExtras">
                     <template v-for="(room, keyExtra, indexExtra) in extraId">
                     <tr v-for="(extras, keyRoom, indexRoom) in room" v-bind:key="`key_${indexExtraId}_${indexRoom}_${indexExtra}`">    <!-- Når vi bruger <template>-tags er vi nødt til at lave en unik key selv -->
                         <!-- vis "error" hvis extras.headline ikke findes (hvis der er skiftet sprog efter valg af extras, og extra ikke findes på det sprog) -->
                         <td v-bind:data-label="$t('ekstra')" colspan="1">{{ extras.headline || $t('fejl') }}</td>
                         <td v-bind:data-label="$t('vaerelse')">{{ keyRoom }}</td>
                         <td v-bind:data-label="$t('antal')">{{extras.antal_personer}}</td>
                         <td data-label="dato">
                            <span style="font-size: 75%; line-height: 50%;" v-for="dato in extras.dates" v-bind:key="dato">
                                {{ dato}}
                            </span>
                        </td>
                        <!-- forsøg kun at vise .toLocaleString hvis extras.* findes -->
                         <td data-label="pris">{{extras.price_per_unit && extras.price_per_unit.toLocaleString('da-DK', {style: 'currency', currency: 'DKK'}) || "0,00 KR." }}</td>
                         <td data-label="pris">{{extras.price_total && extras.price_total.toLocaleString('da-DK', {style: 'currency', currency: 'DKK'}) || "0,00 KR" }}</td>
                     </tr>
                     </template>
                     </template>
                 </tbody>











                <!-- Mellemrum mellem fakturalinier og total -->
                 <tbody>
                     <tr>
                         <td colspan='7'>&nbsp;</td>
                     </tr>

                    <!-- Slut på opsummering, vis totaler -->
                    <template v-if="this.apiLoaded == 1">
                        <tr v-if="this.$store.getters.summaryData.totals.totalDiscount > 0">
                            <td class="subheader" data-label="" colspan='4'>{{ $t('rabat') }}</td>
                            <td class="currency">DKK</td>
                            <td v-bind:data-label="$t('rabat')">{{this.$store.getters.summaryData.totals.totalDiscount.toLocaleString('da-DK', {style: 'currency', currency: 'DKK'})}}</td>
                        </tr>

                     <tr>
                         <td class="subheader" data-label="" colspan='4'>{{ $t('exmoms') }}</td>
                         <td class="currency">DKK</td>
                         <td v-bind:data-label="$t('exmoms')">{{this.$store.getters.summaryData.totals.totalPriceExVat.toLocaleString('da-DK', {style: 'currency', currency: 'DKK'})}}</td>
                     </tr>
                     <tr>
                         <td class="subheader" data-label="" colspan='4'>{{ $t('moms') }}</td>
                         <td class="currency">DKK</td>
                         <td v-bind:data-label="$t('moms')">{{this.$store.getters.summaryData.totals.vat.toLocaleString('da-DK', {style: 'currency', currency: 'DKK'})}}</td>
                     </tr>
                     <tr>
                         <td class="subheader" data-label="" colspan='4'><b>{{ $t('inclmoms') }}</b></td>
                         <td class="currency"><b>DKK</b></td>
                         <td v-bind:data-label="$t('inclmoms')"><b>{{this.$store.getters.summaryData.totals.totalPriceInclVat.toLocaleString('da-DK', {style: 'currency', currency: 'DKK'})}}</b></td>
                     </tr>
                    </template>
                 </tbody>
             </table>
        </div>
        <div class="form">
             <p>{{ $t('rabataftale') }}</p>
             <input type="text" v-model="discountCode" @change="buildRequest()" :placeholder="$t('email')">
        </div>

        <div class="buttonContainer">
            <a href="">
                <div class="continueButton" v-on:click="navigateBack()">
                    <!-- <a>{{ $t('videre')}}</a> -->
                    <a>&laquo; {{$t('tilbage')}} </a>
                </div>
            </a>

            <!-- <router-link to="betaling"> -->
            <router-link to="oplysninger">
                <div class="continueButton">
                    <a>{{ $t('videre')}} &raquo;</a>
                    <!-- <a>{{ $t('betalingsmetode') }} &raquo;</a> -->
                </div>
            </router-link>
        </div>

    </div>
</template>

<script>
import i18n from '@/plugins/i18n';

export default {
    data() {
        return {
            locale: i18n.locale,
            rooms: [],
            roomType: 'rooms',
            extras: {},
            parkings: {},
            apiLoaded: 0,
            discountCode: '',
            timeout: 0,
        };
    },
    watch: {
        discountCode: function () {
            // debounce kode, så vi kun kalder getSummary() (med API kaldet) 1,5 sekunder efter brugeren er stoppet med at taste.
            if (this.timeout) clearTimeout(this.timeout); 
            this.timeout = setTimeout(() => {
                this.buildRequest();
                this.getSummary();
            }, 1500);
        }
    },
    created() {
        this.buildRequest();
        this.getSummary();
    },
    methods: {
        // Bygger det JSON request der skal bruges til 'getSummaryData'
        buildRequest() {
            if(this.$store.getters.bookingInProgress.roomtype === 'parkering') {
                this.roomType = 'parkings';
            } else if(this.$store.getters.bookingInProgress.roomtype === 'moedelokale') {
                this.roomType = 'conference';
            } else if(this.$store.getters.bookingInProgress.roomtype === 'selskabslokale') {
                this.roomType = 'selskab';
            } else {
                this.roomType = 'rooms';
            }

            var rooms = [];
            for(var key = 0; key < this.$store.getters.bookingInProgress.wants.length; key++) {
                if(this.$store.getters.bookingInProgress.wants.hasOwnProperty(key)) {
                    if(this.roomType === 'parkings') {
                        rooms.push({space_no: this.$store.getters.bookingInProgress.wants[key], arrival: this.$store.getters.bookingInProgress.startdate, departure: this.$store.getters.bookingInProgress.enddate});
                    } else {
                        rooms.push({roomnr: this.$store.getters.bookingInProgress.wants[key], arrival: this.$store.getters.bookingInProgress.startdate, departure: this.$store.getters.bookingInProgress.enddate});
                    }
                }
            }
            //console.log(JSON.stringify(rooms));
            this.rooms = rooms;

            var ekstras = [];
            for(var key2 in this.$store.getters.bookingInProgress.ekstras) {
                if(this.$store.getters.bookingInProgress.ekstras.hasOwnProperty(key2)) {
                    ekstras.push({id: key2, qty: this.$store.getters.bookingInProgress.ekstras[key2]});
                }
            }

            //console.log(JSON.stringify(ekstras));
            this.ekstras = ekstras;

            // detailedEkstras

        },
        getSummary() {
            // Hvis postnr er -1 har vi ikke modtaget data fra Vuex på bestillingen - så kan vi ikke lave et bookingSummary - vis fejl istedet.
            if(this.$store.getters.bookingInProgress.hotel && this.$store.getters.bookingInProgress.hotel != -1) {
                this.$store.dispatch("getSummaryData", {
                    'koncern': this.$route.params.koncern,
                    'language': this.locale,
                    'postnr': this.$store.getters.bookingInProgress.hotel,
                    'discount_code': this.discountCode,
                    [this.roomType]: this.rooms,
                    'extras': this.ekstras,
                    'detailedEkstras': this.$store.getters.bookingInProgress.detailedEkstras
                }).then(() => {this.apiLoaded = 1});
                // sæt rabatkode til customerData.email2
                var customerData = this.$store.getters.customerData;
                customerData.email2 = this.discountCode;
                this.$store.dispatch("addCustomerData", customerData);
            }
        },
        navigateBack() {
          if(this.$store.getters.back) {
              // Der er sat en 'back'-værdi i Vuex, send brugeren tilbage til denne side, og slet 'back' i Vuex, da vi har 'brugt' den.
              this.$router.push({ path: this.$store.getters.back }).then(() => { this.$store.dispatch('back', '') });
          } else {
              this.$router.push({ path: "ekstra" });
        }
      }
    }
}
</script>

<style scoped>

.form input[type="text"] {
    background: transparent;
    border: 2px solid white;
    color: white;
    padding: 5px;
}

::placeholder {
    color: white;
    opacity: 0.6;
}

.buttonContainer {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    margin-bottom: 100px;
}

.tabel {
    vertical-align: top;
    background-color: whitesmoke;
    height: 60vh;
    margin-top: 10px;
    margin-bottom: 50px;
    margin-left: 10%;
    margin-right: 10%;
    overflow-y: auto;
    overflow-x: hidden;
}

table {
  border: 1px solid #ccc;
  border-collapse: collapse;
  margin: 0;
  padding: 0;
  width: 100%;
  table-layout: fixed;
}

table tr {
  background-color: #f8f8f8;
  border: 1px solid #ddd;
  padding: .35em;
}

table th,
table td {
  padding: .625em;
  text-align: left;
  color: black;
  overflow: hidden;
}

table th {
  font-size: .95em;
  letter-spacing: .1em;
  text-transform: uppercase;
  word-wrap: break-word;
}

table td {
    font-size: .95em;
}

@media screen and (max-width: 640px) {
  table {
    border: 0;
  }

  table caption {
    font-size: 1.3em;
  }
  
  table thead {
    border: none;
    clip: rect(0 0 0 0);
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    width: 1px;
  }
  
  table tr {
    border-bottom: 3px solid #ddd;
    display: block;
    margin-bottom: .625em;
  }
  
  table td {
    border-bottom: 1px solid #ddd;
    display: block;
    font-size: .8em;
    text-align: right;
  }
  
  table td::before {
    /*
    * aria-label has no advantage, it won't be read inside a table
    content: attr(aria-label);
    */
    content: attr(data-label);
    float: left;
    font-weight: bold;
    text-transform: uppercase;
  }
  
  table td:last-child {
    border-bottom: 0;
  }

  .currency {
      display: none;
  }
  .subheader {
      display: none;
  }
}










.continueButton {
  -webkit-border-radius: 0;
  -moz-border-radius: 0;
  border-radius: 0px;
  -webkit-box-shadow: 0px 4px 4px #666666;
  -moz-box-shadow: 0px 4px 4px #666666;
  box-shadow: 0px 10px 20px #666666;
  color: #000000;
  background-color: rgba(255,255,255,0.87);
  width: 280px;
  height: 80px;  
  font-size: 150%;
  letter-spacing: 1px;
  padding-left: 10px;
  padding-right: 10px;
  margin: 20px;
  white-space: nowrap;
  flex: 0 0 100%;
}

a {
  text-decoration: none;
  color: black;
  text-align: center;
  line-height: 80px;
}


</style>